// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"text-filter__wrapper-3nBR9","filter":"text-filter__filter-1Ukak blocks__base-3OSxK"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/orders-navigation/text-filter/text-filter.css
// module id = 775
// module chunks = 0